export default __webpack_public_path__ + "static/media/183f53235c0d9657.829da553656e4e00022dbea10b504049.svg";